<template>
  <div>
    <div style="padding: 40px">
      <hi-tabs>
        <hi-tab-panel title="Caption History">
          <div>111</div>
        </hi-tab-panel>
        <hi-tab-panel title="Save Hashtags/Caption">
          <div>222</div>
        </hi-tab-panel>
        <hi-tab-panel title="标题3">
          <div>333</div>
        </hi-tab-panel>
      </hi-tabs>
    </div>
  </div>
</template>

<script>
import hiTabs from "../../../components/common/tab/Index.vue";
import hiTabPanel from "../../../components/common/tab/Panel.vue";
export default {
  name: "TabPage",
  components: { hiTabs, hiTabPanel },
};
</script>

<style scoped></style>
